import React, { Component } from 'react';
import styled from 'styled-components';

const SelectArrowSvgStyled = styled.span`
  position: relative;
  display: inline-block;
  width: 100%;
  padding-bottom: 50%; // viewBox height / viewBox width x 100%

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: content-box;
  }
`;

class SelectArrowSvg extends Component {
  render() {
    return (
      <SelectArrowSvgStyled>
        <svg
          viewBox="0 0 30 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
            <g transform="translate(-553.000000, -768.000000)" stroke="#000000" strokeWidth="0.799999952">
              <g transform="translate(335.000000, 479.000000)">
                <polyline
                  transform="translate(233.000000, 289.000000) scale(1, -1) rotate(-45.000000) translate(-233.000000, -289.000000) "
                  points="223 279 243 279 243 299"
                />
              </g>
            </g>
          </g>
        </svg>
      </SelectArrowSvgStyled>
    );
  }
}

export default SelectArrowSvg;



/** WEBPACK FOOTER **
 ** ./src/components/LeadsForm/SelectArrowSvg.js
 **/